<!--
 * @Author: hfxie
 * @Date: 2022-08-30 16:30:40
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2023-11-29 13:32:49
 * @Description: 单个分类区块·左侧
-->
<template>
  <div class="zone-left">

    <template v-for="(block, blockIndex) in list">
      <div class="zone-content" :key="block.id">
        <!-- 头 -->
        <div
          v-if="block.headerShow === true"
          class="zone-header fixed"
          :class="{
            'no-border-top': blockIndex === 0 && toolbarShow === false
          }"
        >
          {{block.nameHeader}}
          <div class="drag-line-right" @mousedown="ChangeItemWidth($event)"></div>
        </div>
        <div class="zone-main">
          <div class="zone-title" v-if="block.name">
            <i
              class="zone-icon"
              :class="{
                'el-icon-caret-bottom': block.isExpand,
                'el-icon-caret-right': !block.isExpand,
              }"
              @click.stop="ChangeExpandZone(block)"
            ></i>
            <span>{{block.name}}</span>
          </div>
          <!-- 行 -->
          <template v-if="block.isExpand">
            <template v-for="row in block.child">
              <ZoneRowLeft :key="'row-' + row.id" :block="block" :row="row" />

            </template>
          </template>

        </div>

      </div>
    </template>


  </div>
</template>

<script>

import ZoneRowLeft from "@/components/List/Zone/Left/ZoneRowLeft";
export default {
  name: "ZoneLeft",
  data() {
    return {
      noTableLineAdjustable: !false,
    };
  },
  components: {
    ZoneRowLeft,
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    toolbarShow: {
      type: Boolean,
      default: () => {
        return true;
      },
    },

  },
  computed: {
    viewWidth() {
      const w = this.$el.style.width;
      return w;
    },
  },
  methods: {
    ChangeExpandZone(zone) {
      // console.log("折叠块: ", zone.name, zone);
      this.$store.commit("set_blockExpand", zone.path[0]);
      this.$store._invoke(this.$outConst.UPDATE_EXPAND, zone);

    },
    /* Dragstart(obj, e) {
      console.log("1.拖拽开始: ", obj);
      e.dataTransfer.setData("dragInfo", JSON.stringify(obj));
      console.log("2.拖拽数据: ", e.dataTransfer.getData("dragInfo"));
    },
    DragEnd(e) {
      console.log("3.拖拽结束: ");
    }, */
    // 拉伸
    ChangeItemWidth(e, _index) {
      const _self = this;
      (!this.noTableLineAdjustable) &&
      (() => {
        console.log(1);
        const odivParent = e.currentTarget.parentNode; // 获取目标父元素
        const dx = e.clientX; // 当你第一次单击的时候，存储x轴的坐标
        const dw = odivParent.offsetWidth; // 存储默认的div的宽度
        const _offsetLeft = odivParent.offsetLeft; // 存储默认的div的距左宽度
        const _uuid = _self.$store.state.uuid;
        const _obj = {}; // 后端缓存数据
        document.getElementById(_uuid).onmousemove = _self.$utils.throttle((e) => {
          let _tableWidth = dw + (e.clientX - dx); // 最新父容器宽度
          const listNode = document.getElementById(_self.$store.state.uuid).getElementsByClassName("list")[0];
          const _listViewWidth = _self.$store.state.local.totalWidth; // parseInt(listNode.style.width);
          const _wbsScrolL = listNode.scrollLeft;
          console.log(_wbsScrolL);
          const max = _wbsScrolL + _listViewWidth - _offsetLeft; // 窗口+已滚动距离
          const min = 50;
          console.log(_offsetLeft, _listViewWidth, _tableWidth, max);
          if (_tableWidth <= min) {
            _tableWidth = min;
          }
          if (_tableWidth >= max) {
            _tableWidth = max;
          }

          if (typeof _index == "number" && _index >= 0) {
            const _newWbsHeaderArr = _self.$utils.deepClone(_self.$store.state.wbsHeaderArr);
            _newWbsHeaderArr[_index].colWidth = _tableWidth;
            _self.$store.commit("set_wbsHeaderArr", _newWbsHeaderArr);

            _obj.width = _tableWidth;
            _obj.index = _index;

          } else {
            // _self.$store.commit("set_treeWidth", _tableWidth);
            _self.$store.state.local.leftWidth = _tableWidth;
            _obj.width = _tableWidth;
          }

        }, 20, false);
        document.getElementById(_uuid).onmouseup = () => {
          document.getElementById(_uuid).onmousemove = null;
          document.getElementById(_uuid).onmouseup = null;
          // 更新后端缓存
          if (_obj.width) {
            console.log(2);
            /* if (typeof _index == "number" && _index >= 0) {
              _self.$store.dispatch("_set_wbsHeaderArr", _obj);
            } else {
              _self.$store.dispatch("_set_treeWidth", _obj);
            } */
          }
        };
        e.stopPropagation();
        e.preventDefault();
        return false;

      })();
    },

  },
};
</script>

<style scoped lang='less'>
.zone-left{
  position: relative;
  width: 100%;
  // background-color: #FFFFFF;
  // Box-shadow: 6px 0px 5px -5px #999;
  .zone-header{
    position: relative;
    height: 28px;
    margin: 0;
    line-height: 28px;
    box-sizing: border-box;
    padding-left: 32px;
    color: #212121;
    background-color: #F8F8F8;
    border-top: 1px solid #D9D9D9;
    border-bottom: 1px solid #D9D9D9;
    .text-oneline;
    // border-right: 1px solid purple;
    &.no-border-top{
      border-top: 0;
    }
    .drag-line-right{
      width: 4px;
      height: 50%;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      box-sizing: border-box;
      border-right: 1px solid #666666;
      border-right: 1px solid var(--border-color, #666666);
      // cursor: ew-resize;
    }
    .zone-content{
      position: relative;
    }
    &.fixed{
      position: sticky;
      z-index: 4;
      top: 0;
      flex-shrink: 0;
      // background-color: #ccc!important;
    }
  }
  .zone-main{
    margin-bottom: 8px;
    .zone-title{ // , .zone-row
      .text-oneline;
      height: 32px;
      line-height: 32px;
      box-sizing: border-box;
      padding-left: 12px;
      color: #212121;
      font-weight: 400;
      .zone-icon{
        color: #666666;
        margin-right: 4px;
        font-size: 12px;
        cursor: pointer;
      };
      .zone-icon,span{
        vertical-align: middle;
      }
    }
    .zone-title{
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      font-weight: 600;
    }


  }
}
</style>
